
/**
 * Generic accessor for deep object properties
 * that can be specified as simple dot-separated strings.
 */
export class NestedProperty {
private splitProp: string[];
/**
 * @param {?} prop
 */
constructor(private prop: string) {
        if (prop.indexOf(".") >= 0) {
            this.splitProp = prop.split(".");
        }
    }
/**
 * @param {?} item
 * @return {?}
 */
public getPropValue(item: any): any {
        if (this.splitProp) {
            let /** @type {?} */ value = item;
            for (const /** @type {?} */ nestedProp of this.splitProp) {
                if (value == null || typeof value === "undefined" || typeof value[nestedProp] === "undefined") {
                    return undefined;
                }
                value = value[nestedProp];
            }
            return value;
        } else {
            return item[this.prop];
        }
    }
}

function NestedProperty_tsickle_Closure_declarations() {
/** @type {?} */
NestedProperty.prototype.splitProp;
/** @type {?} */
NestedProperty.prototype.prop;
}
